"use client"

import { GameResults } from "@/features/casino/components/search/GameResults"
import { useSidebarSearchStore } from "@/stores/sidebar-search"

export function SidebarSearchResults({
  children
}: {
  children: React.ReactNode
}) {
  const query = useSidebarSearchStore((state) => state.query)
  const searching = query.trim().length >= 2

  if (!searching) {
    return children
  }

  return <GameResults query={query} />
}
